import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogBody,
  DialogFooter,
} from '../../../../../components/ui/Dialog';
import { Button } from '../../../../../components/ui/Button';
import ListOfUsers from '../ListOfUsers';
import { Input } from '../../../../../components/ui/Input';
import { apiService } from '../../../../../utils/api';
import UsersForm from '../UsersForm';
import { toast } from 'sonner';

const getPeople = async (current, page, search) =>
  await apiService.get(`/api/v1/company/${current}/user-for-invite/`, {
    params: {
      page: page,
      search: search,
    },
  });

const createEmployee = async (current, data) =>
  await apiService.post(`/api/v1/company/${current}/invite-employee/`, data);

const InvitePeopleModal = ({ visible, onClose, current, roles }) => {
  const [invite, setInvite] = useState(false);
  const [currentInvId, setCurrentInvId] = useState(null);
  const [search, setSearch] = useState(null);
  const [people, setPeople] = useState([]);
  const [nextPeople, setNextPeople] = useState(null);
  const [error, setError] = useState(null);
  const [reset, setReset] = useState(false);
  const [submit, setSubmit] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      if (current) {
        try {
          const { data } = await getPeople(current, 1, null);
          if (data) {
            setPeople(data?.results || []);
            setNextPeople(data?.next);
          }
        } catch {
          //
        }
      }
    };

    fetchData();
  }, [current]);

  const fetchMorePeople = async () => {
    if (nextPeople !== null) {
      try {
        const { data } = await getPeople(current, nextPeople, search);

        if (data) {
          setPeople(people.concat(data?.results || []));
          setNextPeople(data?.next);
        }
      } catch {
        //
      }
    }
  };

  const onSearch = async (e) => {
    setSearch(e?.target?.value);
    try {
      const { data } = await getPeople(current, 1, e?.target?.value);
      if (data) {
        setPeople(data?.results || []);
        setNextPeople(data?.next);
      }
    } catch (_e) {
      //
    }
  };

  const _onInvite = (id) => {
    setInvite(true);
    setCurrentInvId(id);
  };

  const _onSubmit = async (data) => {
    const result = { ...data, user: currentInvId };
    try {
      setSubmit(false);
      const res = await createEmployee(current, result);

      if (res) {
        toast.success(res?.data?.detail);
      }
      setInvite(false);
    } catch (e) {
      setError(e);
    }
  };

  const _onClose = () => {
    setInvite(false);
  };

  const _user = people.find((ele) => ele.id === currentInvId);

  return (
    <>
      <Dialog open={visible} onOpenChange={onClose}>
        <DialogContent className="sm:max-w-[800px]">
          <DialogHeader>
            <DialogTitle>Vyhledat existujícího uživatele</DialogTitle>
          </DialogHeader>
          <DialogBody>
            <Input
              data-testid="invite-people-search-input"
              placeholder="Vyhledat uživatele"
              onChange={onSearch}
              className="h-7.5"
            />
            <ListOfUsers
              users={people}
              fetchMoreData={fetchMorePeople}
              onInvite={_onInvite}
              hasMore={nextPeople !== null ? true : false}
            />
          </DialogBody>
          <DialogFooter>
            <Button data-testid="invite-people-close-btn" key={2} onClick={onClose}>
              Zavřít
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
      <Dialog open={invite} onOpenChange={_onClose}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>{`Založení pracovníka: ${_user?.degree_before} ${_user?.title_f}`}</DialogTitle>
          </DialogHeader>
          <DialogBody>
            <UsersForm
              submitOutside={submit}
              formProps={{}}
              error={error}
              reset={reset}
              roles={roles}
              resetConfirm={() => setReset(false)}
              submit={_onSubmit}
              isNewEmployee={true}
            />
          </DialogBody>
          <DialogFooter>
            <Button
              data-testid="invite-people-create-close-btn"
              key={1}
              variant="outline"
              onClick={() => setInvite(false)}
            >
              Zavřít
            </Button>
            <Button
              data-testid="invite-people-create-submit-btn"
              key={2}
              onClick={() => setSubmit(true)}
            >
              Vytvořit
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default InvitePeopleModal;
